import { ExtendedProduct, RecipeProduct } from "./ApiService";

export function getProductAmountLabel(product: Partial<ExtendedProduct> | Partial<RecipeProduct>) {
  if (product.amount && +product.amount) {
    return `${product.amount} ${product.unit}`
  }
  return 'по вкусу'
}